export const DATE_CRITERION_TYPE = 'date';
export const QUARTER_CRITERION_TYPE = 'quarter';

export const DATE_FORMAT_PATTERN = 'YYYY-MM-DD';
export const DATE_FORMAT_PATTERN_ZONE = 'YYYY-MM-DDZ';
export const DATE_FORMAT_PATTERN_DD_MM_YYYY = 'DD/MM/YYYY';
export const WEEK_FORMAT_PATTERN = 'GGGG-[W]WW';
export const QUARTER_FORMAT_PATTERN = 'YYYY[q]Q';
export const DATE_FORMAT_PATTERN_FOR_CREATION_DATE = 'YYYYMMDD';
export const DATETIME_FORMAT_PATTERN = 'YYYY-MM-DD[T]HH:mm:ss';
export const WEEKYEAR_FORMAT_PATTERN = '[W]WW/GGGG';

export interface FilterDateFormatType {
	inputFormat: string;
	outputFormat: string;
}
